import React from "react";
import { Link } from "react-router-dom";
import { LinkedinLogo, EnvelopeSimple, ArrowUpRight } from "@phosphor-icons/react";
import Logo from "./Logo";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/about", label: "About" },
  { to: "/how-we-help", label: "How We Help" },
  { to: "/offerings", label: "Offerings" },
  { to: "/insights", label: "Insights" },
  { to: "/institutions", label: "For Institutions" },
  { to: "/about-nirmalya", label: "About Nirmalya" },
  { to: "/contact", label: "Contact" },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-navy text-white overflow-hidden">
      <div className="grain absolute inset-0" />
      <div className="relative mx-auto max-w-[1320px] px-6 lg:px-10 pt-20 pb-10">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <Logo inverse />
            <p className="mt-6 max-w-sm text-white/60 leading-relaxed text-[15px]">
              Every founder deserves a Company Building Partner. We help ambitious
              founders transform startups into scalable, enduring companies.
            </p>
            <Link
              to="/contact"
              data-testid="footer-cta"
              className="mt-8 inline-flex items-center gap-2 rounded-full border border-white/25 px-6 py-3 text-sm font-semibold text-white transition-colors duration-300 hover:bg-white hover:text-navy"
            >
              Let's Build Together <ArrowUpRight size={16} weight="bold" />
            </Link>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Navigate</h4>
            <ul className="mt-6 space-y-3">
              {NAV.map((n) => (
                <li key={n.to}>
                  <Link
                    to={n.to}
                    data-testid={`footer-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                    className="text-white/70 transition-colors duration-300 hover:text-white"
                  >
                    {n.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.22em] text-gold">Connect</h4>
            <ul className="mt-6 space-y-4">
              <li>
                <a
                  href="mailto:foun.plus@gmail.com"
                  data-testid="footer-email"
                  className="flex items-center gap-3 text-white/70 transition-colors duration-300 hover:text-white"
                >
                  <EnvelopeSimple size={18} /> foun.plus@gmail.com
                </a>
              </li>
              <li>
                <a
                  href="https://www.linkedin.com/company/founder-plus/"
                  target="_blank"
                  rel="noreferrer"
                  data-testid="footer-linkedin"
                  className="flex items-center gap-3 text-white/70 transition-colors duration-300 hover:text-white"
                >
                  <LinkedinLogo size={18} /> LinkedIn
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-4 border-t border-white/10 pt-8 sm:flex-row sm:items-center sm:justify-between">
          <p className="text-sm text-white/45">
            © {new Date().getFullYear()} Founder+. The Company Building Partner.
          </p>
          <div className="flex items-center gap-4">
            <a
              href="https://www.linkedin.com/company/founder-plus/"
              target="_blank"
              rel="noreferrer"
              aria-label="LinkedIn"
              data-testid="footer-social-linkedin"
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              <LinkedinLogo size={18} />
            </a>
            <a
              href="mailto:foun.plus@gmail.com"
              aria-label="Email"
              data-testid="footer-social-email"
              className="grid h-10 w-10 place-items-center rounded-full border border-white/15 text-white/70 transition-colors duration-300 hover:border-gold hover:text-gold"
            >
              <EnvelopeSimple size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
